import styled from 'styled-components'
import { TextField } from '@material-ui/core'

const Input = styled(TextField)`
  margin-top: 0;
  margin-bottom: 16px;
  width: 100%;
`

export default Input
